import { Zap } from 'lucide-react';

import {
  Label,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@crossnokaye/ux-common';

import { AtlasRouteIds } from '@/components/navigation/constants';
import { NavLink } from '@/components/navigation/nav-link';
import { Icon } from '@/ux-common/components/icon';

export const EaiBadge = () => {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div className={'cursor-pointer'}>
            <NavLink routeId={AtlasRouteIds.EnergyAI}>
              <Icon className="icon-sm bg-conserving" data-testid="EAI-badge">
                <Zap className="glyph glyph-sm fill-white" aria-hidden="true" />
              </Icon>
            </NavLink>
          </div>
        </TooltipTrigger>
        <TooltipContent
          className={'flex flex-col gap-2 items-start justify-start text-left w-[19rem]'}
        >
          <Label className={'font-bold'}>{'High Rate Load Shedding Active'}</Label>
          <Label>
            {
              'Current utility rates are high. Evaporator temperatures will briefly rise to shed load.'
            }
            {'The purple icon will disappear when rates and temperatures return to normal.'}
          </Label>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};
